import * as _4 from 'lodash4';
import { SelectedSectionActionsFacade } from '../../views/course_scheduler/facades/selected_section_actions_facade';
import { StrategySafe } from 'utility-ts-strategy';
import { RegistrationFacade } from '../../views/registration/facades/registration_facade';
import { SelectedSectionActionsMenuQuery } from './queries/selected_section_actions_menu_query';
import { RequestStateQuery } from '../../request_state/queries/request_state_query';

interface ISelectedSectionActionsMenuStrategy {
  (): void;
}

type TSelectedActionsMenuClassify = 'registerSections' | 'waitlistSections';

class MultiSectionActionsMenu {
  private menuSettings = {
    placement: 'bottom',
    subtitle: 'Registration Actions',
    capHeight: true
  };

  private menuId = _4.uniqueId('selected-section-actions-menu-');

  constructor(
    private ngSelectedSectionActionsFacade: SelectedSectionActionsFacade,
    private ngRegistrationFacade: RegistrationFacade,
    private ngSelectedSectionActionsMenuQuery: SelectedSectionActionsMenuQuery,
    private ngRequestStateQuery: RequestStateQuery
  ) {}

  onMenuSelectedEnded(event: CustomEvent) {
    const action = event.detail.value;
    const actionStrategy = new StrategySafe<ISelectedSectionActionsMenuStrategy, TSelectedActionsMenuClassify>({
      registerSections: () => this.ngRegistrationFacade.beginRegistration(),
      waitlistSections: () => this.ngSelectedSectionActionsFacade.openMultiSectionsActionModal('waitlist')
    });
    const invokeActionStrategy = actionStrategy.get(action);
    invokeActionStrategy();
  }
}

angular.module('capability-ng-scheduler').component('selectedSectionActionsMenu', {
  templateUrl:
    'capability-ng-scheduler/src/components/selected_section_actions_menu/selected_section_actions_menu.html',
  controller: MultiSectionActionsMenu
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/selected_section_actions_menu/selected_section_actions_menu.ts